import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from './Header'
import Topsection from './Topsection';
import Footer from './Footer';
import Faq from './Faq';
import { Link } from 'react-router-dom';
import Logoslider from './Logoslider'
import FloatingButton from './FloatingButton';
import Mobilefooterbtn from './Mobilefooterbtn';

import Javanew from './Javanew';
import Fullstack_Python from './Fullstack_Python';
import MernStack from './MernStack';
import Fullstack_Dotnet from './Fullstack_Dotnet';
import Industrial_Tools from './Industrial_Tools';
import C_Language from './C_Language';
import SQL from './SQL';
import WD from './WD';
import Manual_Testing from './Manual_Testing';
import Core_Java from './Core_Java';
import Automation_Testing from './Automation_Testing';
import Mobile_Testing from './Mobile_Testing';
import Linux from './Linux';
import Networking from './Networking';
import Python_Cloud from './Python_Cloud';
import Cloud_Computing from './Cloud_Computing';
import AWS from './AWS';
import DevOps_Tools from './DevOps_Tools';
import DS_With_Python from './DS_With_Python';
import Machine_Learning from './Machine_Learning';
import AI from './AI';
import Deep_Learning from './Deep_Learning';
import Tableau from './Tableau';
import SQL_Cloud from './SQL_Cloud';
import PowerBI from './PowerBI';
import Advanced_EXCEL from './Advanced_EXCEL';
import Statistics from './Statistics';
import Digital_Marketing from './Digital_Marketing';
import AndroidBasics from './AndroidBasics';
import KotlinBasics from './KotlinBasics';
import IntermediateLayouts from './IntermediateLayouts';
import PropertyFinderAppUIProject from './PropertyFinderAppUIProject';
import AdvancedKotlin from './AdvancedKotlin';
import Cyber_Security from './Cyber_Security';

import { Helmet } from 'react-helmet';

// You can later fetch this from an API or database
const courseData = {
  'Full-Stack-Java-Development': {
    title: 'Full Stack Java Development',
    duration: '5 Months',
    pdfUrl: '/assets/brochures/FSD Java with Angular.pdf',
    description: 'Explore the world of Full Stack Development with Java and unlock your potential. Enroll today to gain in-depth knowledge and hands-on experience from an expert in the field.',
  },
  'Full-Stack-Python-Development': {
    title: 'Full Stack Python Development',
    duration: '5 Months',
    pdfUrl: '/assets/brochures/FSD Python.pdf',
    description: 'Explore the world of Full Stack Development with Python and unlock your potential. Enroll today to gain in-depth knowledge and hands-on experience from an expert in the field.',
  },
  'Full-Stack-Dot-Net-Development': {
    title: 'Full Stack .Net Development',
    duration: '5 Months',
    pdfUrl: '/assets/brochures/FSD .NET with Azure.pdf',
    description: 'Explore the world of Full Stack Development with .Net and unlock your potential. Enroll today to gain in-depth knowledge and hands-on experience from an expert in the field.',
  },
  'MERN-Stack-Development': {
    title: 'MERN Stack Development',
    duration: '5 Months',
    pdfUrl: '/assets/brochures/MERN Stack Brochure.pdf',
    description: 'Explore the world of MERN Stack Development with MERN and unlock your potential. Enroll today to gain in-depth knowledge and hands-on experience from an expert in the field.',
  },
  'Software-Testing': {
    title: 'Software Testing',
    duration: '5 Months',
    pdfUrl: '/assets/brochures/Software Testing Brochure.pdf',
    description: 'Explore the world of Testing with Manual & Automation and unlock your potential. Enroll today to gain in-depth knowledge and hands-on experience from an expert in the field.',
  },
  'Cloud-Computing': {
    title: 'Cloud Computing',
    duration: '5 Months',
    pdfUrl: '/assets/brochures/MCA with AWS DevOps Brochure.pdf',
    description: 'Explore the world of Cloud Computing with AWS DevOps and unlock your potential. Enroll today to gain in-depth knowledge and hands-on experience from an expert in the field.',
  },
  'Data-Science-And-Data-Analytics': {
    title: 'Data Science & Data Analytics',
    duration: '6 Months',
    pdfUrl: '/assets/brochures/Data Science & Data Analytics.pdf',
    description: 'Explore the world of Data Science & Data Analytics and unlock your potential. Enroll today to gain in-depth knowledge and hands-on experience from an expert in the field.',
  },
  'Data-Analytics': {
    title: 'Data Analytics',
    duration: '4 Months',
    pdfUrl: '/assets/brochures/Data Analytics.pdf',
    description: 'Explore the world of Data Analyticss and unlock your potential. Enroll today to gain in-depth knowledge and hands-on experience from an expert in the field.',
  },
  'Digital-Marketing': {
    title: 'Digital Marketing',
    duration: '3 Months',
    pdfUrl: '/assets/brochures/Master in Digital Marketing Brochure.pdf',
    description: 'Explore the world of Digital Marketing and unlock your potential. Enroll today to gain in-depth knowledge and hands-on experience from an expert in the field.',
  },
  'Cyber-Security': {
    title: 'Cyber Security',
    duration: '6 Months',
    pdfUrl: '/assets/brochures/Cyber Security.pdf',
    description: 'Explore the world of Cyber Security and unlock your potential. Enroll today to gain in-depth knowledge and hands-on experience from an expert in the field.',
  },
  'Android-Development': {
    title: 'Android Development',
    duration: '5 Months',
    pdfUrl: '/assets/brochures/Android Brochure.pdf',
    description: 'Explore the world of Android Development and unlock your potential. Enroll today to gain in-depth knowledge and hands-on experience from an expert in the field.',
  },
};

const CourseDetails = () => {
  const { slug } = useParams();
  const course = courseData[slug];

  const [errors, setErrors] = useState({});
   const [errors1, setErrors1] = useState({});

  const [whatsappNumber, setWhatsappNumber] = useState('');

  const [otp, setOtp] = useState('');
  const [isVerifyDisabled, setIsVerifyDisabled] = useState(true);

  const [formData, setFormData] = useState({
      name: '',
      email: '',
      contact: '',
      branch: '',
      course: '',
  });

  const [formData1, setFormData1] = useState({
      name1: '',
      email1: '',
      contact1: '',
      branch1: '',
      course1: '',
  });

  useEffect(() => {
    if (course?.title) {
      setFormData((prev) => ({ ...prev, course: course.title }));
      setFormData1((prev) => ({ ...prev, course1: course.title }));
    }
  }, [course]);

  if (!course) {
    return (
      <div className="p-6">
        <h1 className="text-xl font-bold">Course not found</h1>
        <p>We couldn't find details for this course.</p>
      </div>
    );
  }

  //Brochure download
  const handleDownload = (pdfUrl) => {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = pdfUrl.substring(pdfUrl.lastIndexOf('/') + 1);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


//enquiry form backend
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name.endsWith('1')) {
      setFormData1((prev) => ({ ...prev, [name]: value }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const validateForm = (data, isModal = false) => {
    const newErrors = {};
    const prefix = isModal ? '1' : '';

    const name = data[`name${prefix}`].trim();
    const email = data[`email${prefix}`].trim();
    const contact = data[`contact${prefix}`].trim();
    const branch = data[`branch${prefix}`];

    if (!name) newErrors[`name${prefix}`] = 'Name is required.';
    else if (!/^[A-Za-z ]+$/.test(name)) newErrors[`name${prefix}`] = 'Only letters and spaces allowed.';
    else if (name.length < 2) newErrors[`name${prefix}`] = 'At least 2 characters required.';

    if (!email) newErrors[`email${prefix}`] = 'Email is required.';
    else if (!/\S+@\S+\.\S+/.test(email)) newErrors[`email${prefix}`] = 'Invalid email format.';

    if (!contact) {
      newErrors[`contact${prefix}`] = 'Contact is required.';
    } else if (!/^\d{10}$/.test(contact)) {
      newErrors[`contact${prefix}`] = 'Must be exactly 10 digits (numbers only).';
    }


    if (!branch) newErrors[`branch${prefix}`] = 'Branch is required.';

    return newErrors;
  };


  const submitForm = async (data, isModal = false) => {
    const prefix = isModal ? '1' : '';
    const errors = validateForm(data, isModal);

    if (Object.keys(errors).length > 0) {
      isModal ? setErrors1(errors) : setErrors(errors);
      return;
    }

    isModal ? setErrors1({}) : setErrors({});

    const payload = {
      name: data[`name${prefix}`],
      email: data[`email${prefix}`],
      contact: data[`contact${prefix}`],
      branch: data[`branch${prefix}`],
      course: data[`course${prefix}`],
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE}/enquiries`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (response.ok) {
        alert('Enquiry submitted!');
        handleDownload(course.pdfUrl);
        isModal
          ? setFormData1({ name1: '', email1: '', contact1: '', branch1: '', course1: course.title })
          : setFormData({ name: '', email: '', contact: '', branch: '', course: course.title });
      } else {
        alert(result.error || 'Failed to submit enquiry');
      }
    } catch (err) {
      console.error(err);
      alert('Error submitting enquiry');
    }
  };


  //otp
  const handleSendOtp = async () => {
  if (!whatsappNumber || whatsappNumber.length < 10) {
    alert("Please enter a valid WhatsApp number.");
    return;
  }

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE}/send-whatsapp-otp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ number: whatsappNumber }),
    });

    const data = await response.json();

    if (data.success) {
      // Show next modal manually using Bootstrap
      // const otpModal = new bootstrap.Modal(document.getElementById('exampleModalgetotp'));
      // otpModal.show();
      console.log("form");
      console.log(whatsappNumber);
      // $("#exampleModalgetotp").show();

      const whatsappModal = window.bootstrap.Modal.getInstance(document.getElementById('whatsappModal'));
      if (whatsappModal) whatsappModal.hide();

      const otpModal = new window.bootstrap.Modal(document.getElementById('exampleModalgetotp'));
      otpModal.show();

    } else {
      alert("Failed to send OTP: " + data.message);
    }
  } catch (err) {
    console.error(err);
    alert("Error sending OTP.");
  }
};

    const handleVerifyOtp = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE}/send-whatsapp-otp/verify-otp`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ otp, number: whatsappNumber }), // make sure you have whatsappNumber state too
        });

        const data = await response.json();

        if (data.success) {
          alert("OTP verified successfully!");

          // Close the OTP modal
          const otpModal = window.bootstrap.Modal.getInstance(document.getElementById('exampleModalgetotp'));
          if (otpModal) otpModal.hide();

          // Now allow the download
          handleDownload(course.pdfUrl); // Make sure `handleDownload` is defined
        } else {
          alert("Invalid OTP. Please try again.");
        }
      } catch (err) {
        console.error("Error verifying OTP:", err);
        alert("Something went wrong. Please try again.");
      }
    };



  return (
    <div>
        <Helmet>
                <title>Fortune Cloud Technologies | {course.title}</title>
                <meta name="description" content="Explore courses and training programs at Fortune Cloud Technologies. Learn with experts and get placed." />
                <meta name="robots" content="index, follow" />
        </Helmet>
        <Topsection/>
        <Header/>


        <div className='bg-hero1 bgcolor1'>
                <div className='container myfont1'>
                  <div className='row animate__animated animate__slow animate__fadeInDown'>
                    <div className='col-md-8 text-start mt-4'>
                      <h2 className='coursetitle1 mb-4 fw-bold'>{course.title}</h2>
                      <p className='fw-semibold'>{course.description}</p>
        
                      <div className='d-none d-sm-block'>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="card text-center mb-2 w-100">
                            <div className="card-body">
                              <h6 className="card-title">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-calendar2-week" viewBox="0 4 16 10">
                                  <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z"/>
                                  <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5zM11 7.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm-3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm-5 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z"/>
                                </svg>&nbsp;<span className='fw-bold'>Course Duration:</span>
                              </h6>
                              <p className="card-text">{course.duration}</p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="card text-center mb-2">
                            <div className="card-body">
                              <h6 className="card-title">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-backpack" viewBox="0 0 16 16">
                                  <path d="M4.04 7.43a4 4 0 0 1 7.92 0 .5.5 0 1 1-.99.14 3 3 0 0 0-5.94 0 .5.5 0 1 1-.99-.14M4 9.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5zm1 .5v3h6v-3h-1v.5a.5.5 0 0 1-1 0V10z"/>
                                  <path d="M6 2.341V2a2 2 0 1 1 4 0v.341c2.33.824 4 3.047 4 5.659v5.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 13.5V8a6 6 0 0 1 4-5.659M7 2v.083a6 6 0 0 1 2 0V2a1 1 0 0 0-2 0m1 1a5 5 0 0 0-5 5v5.5A1.5 1.5 0 0 0 4.5 15h7a1.5 1.5 0 0 0 1.5-1.5V8a5 5 0 0 0-5-5"/>
                                </svg>&nbsp;<span className='fw-bold'>Mode Of Training:</span>
                              </h6>
                              <p className="card-text">Classroom & Online</p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="card text-center mb-2">
                            <div className="card-body">
                              <h6 className="card-title">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-journal" viewBox="0 0 16 16">
                                  <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2"/>
                                  <path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z"/>
                                </svg>&nbsp;<span className='fw-bold'>Case Studies:</span>
                              </h6>
                              <p className="card-text">20+</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      </div>
        
                      <div className='d-block d-sm-none'>
                        <div className="mt-4 d-flex justify-content-center align-items-center flex-column">
                          <ul className="list-unstyled text-start">
                            <li><i className="bi bi-check-circle"></i>&nbsp;&nbsp;<strong className='fs-5'>Course Duration:</strong> 5 Months</li>
                            <li><i className="bi bi-check-circle"></i>&nbsp;&nbsp;<strong className='fs-5'>Mode Of Training:</strong> Classroom & Online</li>
                            <li><i className="bi bi-check-circle"></i>&nbsp;&nbsp;<strong className='fs-5'>Case Studies:</strong> 20+</li>
                          </ul>
                        </div>
                      </div>
        
                      <br/>
                    
                      <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-3 py-2">
                        {/* <button className="btn btn-outline-light px-4 py-2 fw-semibold shadow-sm" type="button" data-bs-toggle="modal" data-bs-target="#whatsappModal">
                          Download Brochure
                        </button> */}
                        <button className="btn btn-outline-light px-4 py-2 fw-semibold shadow-sm" type="button" data-bs-toggle="modal" data-bs-target="#quickenquiryformnew">
                          Download Brochure
                        </button>
                        <Link className="btn btn-outline-light px-4 py-2 fw-semibold shadow-sm" to="/batchschedule">
                          Free Demo Session Available
                        </Link>
                      </div>
        
        
                    </div>
                    <div className='col-md-4'>
        
                      <div className='container mt-4 mb-4 bg-white rounded myfont1'>
                        <h3 className='text-white pt-2 pb-2 bgcolor1 myborderbottom fw-bold'>Enquire Now</h3>
                        <form className="p-4" onSubmit={(e) => { e.preventDefault(); submitForm(formData, false); }}>
                          <div className="form-group text-start">
                            <input
                              type="text"
                              placeholder="Enter your name"
                              className={`form-control mb-2 rounded-0 ${errors.name ? 'is-invalid' : ''}`}
                              name="name"
                              value={formData.name}
                              onChange={handleChange}
                            />
                            {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                          </div>

                          <div className="form-group text-start">
                            <input
                              type="email"
                              placeholder="Enter your email"
                              className={`form-control mb-2 rounded-0 ${errors.email ? 'is-invalid' : ''}`}
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                            />
                            {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                          </div>

                          <div className="form-group text-start">
                            <input
                              type="number"
                              placeholder="Enter your contact"
                              className={`form-control mb-2 rounded-0 ${errors.contact ? 'is-invalid' : ''}`}
                              name="contact"
                              value={formData.contact}
                              onChange={handleChange}
                            />
                            {errors.contact && <div className="invalid-feedback">{errors.contact}</div>}
                          </div>

                          <div className="form-group text-start">
                            <select
                              name="branch"
                              className={`form-control mb-4 rounded-0 ${errors.branch ? 'is-invalid' : ''}`}
                              value={formData.branch}
                              onChange={handleChange}
                            >
                              <option value="" disabled>Select Branch</option>
                              <option value="Shivajinagar, Pune">Shivajinagar, Pune</option>
                              <option value="Pimpri-Chinchwad, Pune">Pimpri-Chinchwad, Pune</option>
                              <option value="Bengaluru/Bangalore">Bengaluru/Bangalore</option>
                            </select>
                            {errors.branch && <div className="invalid-feedback">{errors.branch}</div>}
                          </div>

                          <input type="hidden" name="course" value={formData.course} onChange={(e) =>setFormData((prev) => ({ ...prev, course: e.target.value }))}/>
                          
                          <div className="d-grid pb-3 mb-2">
                            <button className="btn btn-primary fw-bold" type="submit">Submit</button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


    {/* Course Content */}
    <div className='container myfont1'>
      <div className='row'>
        <div className='col-md-8 text-start mt-4'>
          <h2 className='text-center mt-2 mb-4 fw-bold'>Course Content</h2>

            <div className="accordion" id="accordionCourses">

                {/* fullstack courses */}
                {course.title === "Full Stack Java Development" ?(
                  <div>
                    <C_Language/>
                    <SQL/>
                    <WD/>
                    <Javanew/>
                  </div>
                ):("")}

                {course.title === "Full Stack Python Development" ?(
                  <div>
                    <C_Language/>
                    <SQL/>
                    <WD/>
                    <Fullstack_Python/>
                  </div>
                ):("")}

                {course.title === "Full Stack .Net Development" ?(
                  <div>
                    <C_Language/>
                    <SQL/>
                    <WD/>
                    <Fullstack_Dotnet/>
                  </div>
                ):("")}

                {course.title === "Software Testing" ?(
                  <div>
                    <C_Language/>
                    <SQL/>
                    <Core_Java/>
                    <Manual_Testing/>
                    <Automation_Testing/>
                    <Mobile_Testing/>
                  </div>
                ):("")}

                {/* mernstack course */}
                {course.title === "MERN Stack Development" ?(
                  <div>
                    <WD/>
                    <MernStack/>
                  </div>
                ):("")}

                {/* Industrial Tools */}
                {(course.title === "Full Stack Java Development" || course.title === "Full Stack Python Development" || course.title === "Full Stack .Net Development" || course.title === "MERN Stack Development" || course.title === "Software Testing") ? ( 
                  <Industrial_Tools/>
                ):("")}


                {/* cloud computing */}
                {course.title === "Cloud Computing" ?(
                  <div>
                    <Linux/>
                    <Networking/>
                    <Python_Cloud/>
                    <Cloud_Computing/>
                    <AWS/>
                    <DevOps_Tools/>
                  </div>
                ):("")}

                {/* Data Science & Data Analytics */}
                {course.title === "Data Science & Data Analytics" ?(
                  <div>
                    <DS_With_Python/>
                    <Machine_Learning/>
                    <AI/>
                    <Deep_Learning/>
                    <Tableau/>
                    <SQL_Cloud/>
                    <PowerBI/>
                    <Advanced_EXCEL/>
                    <Statistics/>
                  </div>
                ):("")}

                {/* Data Analytics */}
                {course.title === "Data Analytics" ?(
                  <div>
                    <DS_With_Python/>
                    <SQL_Cloud/>
                    <PowerBI/>
                    <Advanced_EXCEL/>
                    <Statistics/>
                  </div>
                ):("")}

                {/* Digital Marketing */}
                {course.title === "Digital Marketing" ?(
                  <div>
                    <Digital_Marketing/>
                  </div>
                ):("")}

                {/* Android Development */}
                {course.title === "Android Development" ?(
                  <div>
                    <AndroidBasics/>
                    <KotlinBasics/>
                    <IntermediateLayouts/>
                    <PropertyFinderAppUIProject/>
                    <AdvancedKotlin/>
                  </div>
                ):("")}

                {/* Cyber Security */}
                {course.title === "Cyber Security" ?(
                  <div>
                    <Cyber_Security/>
                  </div>
                ):("")}



            </div>


        </div>
        <div className='col-md-4 text-start mt-4 myfont1'>
          <h2 className='text-center mt-2 mb-4 fw-bold'>Training Features</h2>
          <div className="card mb-2">
            <div className="card-body">
              <p className="card-text lead"><strong>
                <ul>
                  <li>Expert Faculty</li>
                  <li>Hands-on Projects</li>
                  <li>Placement Assistance</li>
                  <li>Interactive Sessions</li>
                  <li>Doubt Clearing Sessions</li>
                  <li>Soft Skills Training</li>
                </ul>
                </strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>


        {/* Free Interview Assessment */}
    <div className="container-fluid text-center bgcolor1 text-white p-4 myfont1">
      <h2 className='fw-bold'>100% Skills = 100% Job</h2>
      {/* <h2 className='fw-bold'>Free Interview Assessment</h2> */}
          {/* <button
            type="button"
            className="btn btn-outline-light bg-light px-4 py-2 text-dark fw-semibold shadow-sm"
            data-bs-toggle="modal"
            data-bs-target="#whatsappModal"
          >
            Click Here To Download
          </button> */}

        <div class="modal fade" id="whatsappModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-sm">
            <div class="modal-content">
              <div class="modal-body">
                <strong>Verify your WhatsApp Number <span className='text-danger'>*</span></strong><br></br><br></br>
                <input
                  type='number'
                  placeholder='Enter WhatsApp Number'
                  className='form-control rounded-0'
                  value={whatsappNumber}
                  onChange={(e) => setWhatsappNumber(e.target.value)}
                />
              </div>
              <div class="modal-footer d-flex justify-content-center">
                  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => handleDownload(course.pdfUrl)}>Close</button>
                  {/* <button className="btn btn-primary" data-bs-target="#exampleModalgetotp" data-bs-toggle="modal">Get OTP</button> */}
                  <button className="btn btn-primary" onClick={handleSendOtp} >Get OTP</button>

              </div>
            </div>
          </div>
        </div>

        {/* otp modal */}

        <div class="modal fade" id="exampleModalgetotp" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-sm">
            <div class="modal-content">
              <div class="modal-body">
                <input
                  type="number"
                  placeholder="Enter OTP Here"
                  className="form-control rounded-0"
                  value={otp}
                  onChange={(e) => {
                    const value = e.target.value;
                    setOtp(value);
                    setIsVerifyDisabled(value.length !== 6); // Enable only when OTP has 6 digits
                  }}
                />
              </div>
              <div class="modal-footer d-flex justify-content-center">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => handleDownload(course.pdfUrl)}>Close</button>
                <button
                  className="btn btn-primary"
                  disabled={isVerifyDisabled}
                  onClick={handleVerifyOtp} // You can define this function later
                >
                  Verify
                </button>
              </div>
            </div>
          </div>
        </div>



        <div class="modal fade" id="quickenquiryformnew" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-sm">
            <div class="modal-content">
              <form className="p-4" onSubmit={(e) => { e.preventDefault(); submitForm(formData1, true); }}>
              <div class="modal-body">
                  <h3 className='text-black pt-2 pb-2 fw-bold'>Enquire Now</h3>
                          <div className="form-group text-start">
                            <input
                              type="text"
                              placeholder="Enter your name"
                              className={`form-control mb-2 rounded-0 ${errors1.name1 ? 'is-invalid' : ''}`}
                              name="name1"
                              value={formData1.name1}
                              onChange={handleChange}
                            />
                            {errors1.name1 && <div className="invalid-feedback">{errors1.name1}</div>}
                          </div>

                          <div className="form-group text-start">
                            <input
                              type="email"
                              placeholder="Enter your email"
                              className={`form-control mb-2 rounded-0 ${errors1.email1 ? 'is-invalid' : ''}`}
                              name="email1"
                              value={formData1.email1}
                              onChange={handleChange}
                            />
                            {errors1.email1 && <div className="invalid-feedback">{errors1.email1}</div>}
                          </div>

                          <div className="form-group text-start">
                            <input
                              type="number"
                              placeholder="Enter your contact"
                              className={`form-control mb-2 rounded-0 ${errors1.contact1 ? 'is-invalid' : ''}`}
                              name="contact1"
                              value={formData1.contact1}
                              onChange={handleChange}
                            />
                            {errors1.contact1 && <div className="invalid-feedback">{errors1.contact1}</div>}
                          </div>

                          <div className="form-group text-start">
                            <select
                              name="branch1"
                              className={`form-control mb-4 rounded-0 ${errors1.branch1 ? 'is-invalid' : ''}`}
                              value={formData1.branch1}
                              onChange={handleChange}
                            >
                              <option value="" disabled>Select Branch</option>
                              <option value="Shivajinagar, Pune">Shivajinagar, Pune</option>
                              <option value="Pimpri-Chinchwad, Pune">Pimpri-Chinchwad, Pune</option>
                              <option value="Bengaluru/Bangalore">Bengaluru/Bangalore</option>
                            </select>
                            {errors1.branch1 && <div className="invalid-feedback">{errors1.branch1}</div>}
                          </div>

                          <input type="hidden" name="course1" value={formData1.course1} onChange={(e) =>setFormData1((prev) => ({ ...prev, course1: e.target.value }))}/>
                          
                        
              </div>
              <div class="modal-footer d-flex justify-content-center">
                  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => handleDownload(course.pdfUrl)}>Close</button>
                  <button className="btn btn-primary" type="submit">Submit</button>

              </div>
              </form>
            </div>
          </div>
        </div>           



    </div>  


        <Faq/>
        <Logoslider/>
        <Footer/>
        <FloatingButton />
        <Mobilefooterbtn />
    </div>
  );
};

export default CourseDetails;
